<script setup>
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  caption: {
    type: String,
    default: null,
  },
})

const emit = defineEmits(['update:modelValue'])
</script>

<template>
  <q-dialog
    :model-value="props.modelValue"
    position="bottom"
    @update:model-value="value => emit('update:modelValue', value)"
  >
    <q-card class="bottom-sheet column no-wrap">
      <div class="bottom-sheet__grip" />
      <q-card-section class="q-pt-xs q-pb-sm">
        <div class="text-h6 ellipsis">{{ props.title }}</div>
        <div v-if="props.caption" class="text-caption text-grey-7">{{ props.caption }}</div>
      </q-card-section>
      <q-card-section class="col scroll q-pa-none q-pb-md">
        <slot />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<style scoped lang="scss">
.bottom-sheet {
  width: 100vw;
  max-width: 100vw;
  max-height: 80vh;
  border-radius: $app-border-radius $app-border-radius 0 0;
  padding-bottom: env(safe-area-inset-bottom);
}

.bottom-sheet__grip {
  flex-shrink: 0;
  width: 2.5rem;
  height: 0.25rem;
  margin: 0.5rem auto 0.25rem;
  border-radius: 1rem;
  background: $grey-4;
}
</style>
